const AUTH_KEY = 'veloe-auth'

const parseJwt = token => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  // Support both browser and Node environments
  if (typeof window !== 'undefined' && typeof window.atob === 'function') {
    return JSON.parse(window.atob(base64))
  }
  // Node: use Buffer
  return JSON.parse(Buffer.from(base64, 'base64').toString('utf8'))
}

// Fallback in-memory storage when sessionStorage is not available (Node test env)
let memoryStore = {}
const storage =
  typeof sessionStorage !== 'undefined' && sessionStorage
    ? sessionStorage
    : {
        setItem: (k, v) => {
          memoryStore[k] = String(v)
        },
        getItem: k =>
          Object.prototype.hasOwnProperty.call(memoryStore, k) ? memoryStore[k] : null,
        removeItem: k => {
          delete memoryStore[k]
        }
      }

const objectSetter = key => obj => {
  storage.setItem(key, JSON.stringify(obj))
}

const objectRemover = key => () => {
  storage.removeItem(key)
}

const objectGetter = key => () => {
  const json = storage.getItem(key)
  try {
    return JSON.parse(json)
  } catch (e) {
    console.warn(`Erro parsing storage key "${key}" object. value="${json}"`)
    return null
  }
}

const getAuthObj = objectGetter(AUTH_KEY)
export const setAuthObj = objectSetter(AUTH_KEY)
export const removeAuthObj = objectRemover(AUTH_KEY)

export const getAccessToken = () => {
  const authObj = getAuthObj()
  if (!authObj || !authObj.access_token) return null
  return authObj.access_token
}

export const getAccessTokenObject = () => {
  const acessToken = getAccessToken()
  return (acessToken && parseJwt(acessToken)) || null
}

export const getRefreshToken = () => {
  const authObj = getAuthObj()
  if (!authObj || !authObj.refresh_token) return null
  return authObj.refresh_token
}
